export default function PaymentDashboardNotAvailable() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#ffffff",
        paddingLeft: "16px",
        paddingRight: "16px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          maxWidth: "448px",
          textAlign: "center",
          gap: "32px",
        }}
      >
        {/* Icon */}
        <div
          style={{
            position: "relative",
            width: "96px",
            height: "96px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg
            viewBox="0 0 120 120"
            style={{
              width: "100%",
              height: "100%",
              color: "black", // gray-200
            }}
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <circle cx="60" cy="60" r="55" strokeOpacity="0.5" />

            <rect x="42" y="62" width="36" height="32" rx="3" />

            <path
              d="M 50 62 Q 50 38 60 38 Q 70 38 70 62"
              strokeLinecap="round"
            />

            <circle cx="60" cy="72" r="3" fill="currentColor" />
          </svg>
        </div>

        {/* Heading */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <h1
            style={{
              fontSize: "30px",
              fontWeight: 700,
              color: "black",
              letterSpacing: "-0.02em",
              margin: 0,
            }}
          >
            Access Limited
          </h1>

          {/* <div
            style={{
              height: "4px",
              width: "48px",
              background: "linear-gradient(to right, #111827, #9ca3af)", // gray-900 → gray-400
              borderRadius: "9999px",
            }}
          /> */}
        </div>

        {/* Description */}
        <p
          style={{
            fontSize: "16px",
            color: "#4b5563", // gray-600
            lineHeight: 1.6,
            margin: 0,
          }}
        >
          Payment Dashboard is not available for accounts having more than {""}
          <span
            style={{
              fontWeight: 600,
              color: "#111827",
              marginLeft: "4px",
            }}
          >
            30 doctors
          </span>
          . Please check analytics
        </p>
        <button
          className=" dr-text-darwin-neutral-0 dr-bg-darwin-primary-primary hover:dr-bg-darwin-hover-primary dr-space-x-8 dr-px-12 dr-py-10 dr-flex dr-justify-center dr-items-center dr-rounded-8 focus:dr-ring-0 focus:dr-outline-1.5 focus:dr-outline focus:dr-outline-offset-2 focus:dr-outline-darwin-yellow-primary  disabled:dr-pointer-events-none"
          onClick={() => {
            window.open("https://analytics.eka.care", "_blank");
          }}
        >
          Go To Analytics
        </button>
      </div>
    </div>
  );
}
